<div class="row">
    <div class="col-sm-12">
        <div *ngIf="!disabledForNonAdmin" class="new-button-div">
            <a [routerLink]="[linkToNew]" class="btn btn-default">
                + New Term
            </a>
        </div>
        <eil-fundterms-list></eil-fundterms-list>
    </div>
</div>
